import { useTranslation } from 'react-i18next';
import { formatDkk } from '../../../utils/currencyUtils';
import styles from './TemplateStatsRow.module.css';

type TemplateStatsVariant = 'card' | 'header';

interface TemplateStatsRowProps {
  weekCount: number;
  interventionCount: number;
  reimbursement: number;
  variant?: TemplateStatsVariant;
}

export const TemplateStatsRow = ({
  weekCount,
  interventionCount,
  reimbursement,
  variant = 'card'
}: TemplateStatsRowProps) => {
  const { t, i18n } = useTranslation();

  return (
    <div className={`${styles.stats} ${styles[variant]}`}>
      <div className={styles.stat}>
        <span className={styles.statValue}>{weekCount}</span>
        <span className={styles.statLabel}>{t('config-card-weeks')}</span>
      </div>
      <div className={styles.statDivider} />
      <div className={styles.stat}>
        <span className={styles.statValue}>{interventionCount}</span>
        <span className={styles.statLabel}>{t('config-card-interventions')}</span>
      </div>
      <div className={styles.statDivider} />
      <div className={styles.stat}>
        <span className={styles.statValue}>{formatDkk(reimbursement, i18n.language)}</span>
        <span className={styles.statLabel}>{t('config-card-total-reimbursement')}</span>
      </div>
    </div>
  );
};
